import { Pipe, PipeTransform } from '@angular/core';
import { DateManager } from '../managers/date.manager';

@Pipe({
    name: 'millisecondsDigitalClock'
})
export class MillisecondsDigitalClockPipe implements PipeTransform {

    constructor() { }

    transform(ms) {
        if (!ms) return '0';
        let data = '';
        let duration = DateManager.durationFormat(ms, 'milliseconds');
        if (duration.years) data += duration.years + (duration.years > 1 ? ' años ' : ' año ');
        if (duration.months) data += duration.months + (duration.months > 1 ? ' meses ' : ' mes ');
        if (duration.days) data += duration.days + (duration.days > 1 ? ' días ' : ' día ');
        if (duration.hours) data += duration.hours + (duration.hours > 1 ? ' horas ' : ' hora ');
        if (duration.minutes) data += duration.minutes + (duration.minutes > 1 ? ' minutos ' : ' minuto ');
        if (duration.seconds) data += duration.seconds + (duration.seconds > 1 ? ' segundos ' : ' segundo ');
        return data;
    }

}